import ProductModel                   from '@models/shop/ProductModel';
import ProductVariantSalesStatusModel from '@models/shop/ProductVariantSalesStatusModel';
import ProductVariantStatusModel      from '@models/shop/ProductVariantStatusModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import ShopServiceModel               from '@/models/ShopServiceModel';
import TimestampAble                  from '@widesk-core/models/traits/TimestampAble';
import Blamable                       from '@/models/traits/Blamable';
import { RenderNameProps }            from '@widesk-ui/mixins/ApiModelRenderName';
import Translatable                   from '@widesk-core/models/traits/Translatable';
import AccessTypeModel                from '@models/scaf/AccessTypeModel';
import PagedCollection                from '@widesk-core/models/PagedCollection';

@model.urnResource('product_variant')
@doc.path('/product_variants/{?id}')
export default class ProductVariantModel extends Blamable(TimestampAble(Translatable(ShopServiceModel, {
	'title': true,
	'shortTitle': true,
}))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'product': id;
		'product.entertainment': id;
		'product.entertainment.entertainmentUrn': Urn;
		'product.productStatus': id;
		'product.productStatus.reference': Shop_ProductStatusReference;
		'product.productTaxonomies.taxonomy': id;
		'product.productType': id;
		'product.productType.reference': Shop_ProductTypeReference;
		'productVariantSalesStatus': id;
		'productVariantSalesStatus.reference': Shop_ProductVariantSalesStatusReference;
		'productVariantStatus': id;
		'productVariantStatus.reference': Shop_ProductVariantStatusReference;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'position': string;
		'product.entertainment.label': string;
		'product.id': string;
		'updatedAt': string;
	};	

	@doc.date declare endDate: Dayjs;
	@doc.number declare maxQuantity: number;
	@doc.number declare maxQuantityPerOrder: number;
	@doc.number declare position: number;
	@doc.model(ProductModel) declare product: ProductModel;
	@doc.model(ProductVariantSalesStatusModel) declare productVariantSalesStatus: ProductVariantSalesStatusModel;
	@doc.model(ProductVariantStatusModel) declare productVariantStatus: ProductVariantStatusModel;
	@doc.date declare startDate: Dayjs;

	public renderName(props?: RenderNameProps<this> & ProductVariantNameProps) {
		return super.renderName(props);
	}

	public accessType = new AccessTypeModel();

	public async fetchAccessType() {
		const collection = new PagedCollection(AccessTypeModel);
		await collection
			.clear()
			.setItemsPerPage(1)
			.setFilter('sourceUrn', this.urn)
			.list();

		const model = collection.first();

		if (model) this.accessType.set(collection.first()?.attributes);

		this.accessType.setIsLoaded(true);
	}
}